import { InjectionToken } from '@angular/core';
import type { ApiConfiguration } from './app-environment';

export const API_CONFIGURATION = new InjectionToken<ApiConfiguration>('API_CONFIGURATION');
export const PUBLIC_SITE_URL = new InjectionToken<string>('PUBLIC_SITE_URL');
